import { Dialog, Slide } from "@mui/material";
import React, { forwardRef, useRef, useState } from "react";
import ExoForm from "../exo/ExoForm";
import { useTranslation } from "react-i18next";
import { DBUploadDemViaBackend } from "../../api/dbRequest";
import { LoadingBlur } from "../LoadingBlur";
import ExoAlert from "../exo/ExoAlert";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const UploadDemFile = ({
  projectId,
  onClose,
  onUploadQueued,
  open,
}) => {
  const { t } = useTranslation();
  const [progress, setProgress] = useState(null);
  const uploadControllerRef = useRef(null);

  const fields = [
    {
      label: t("Upload DEM file"),
      subLabel: t("Drag or drop your file here or click to upload"),
      key: "demFile",
      type: "upload",
    },
  ];

  function handleSave(data) {
    setAlert(null);
    setProgress(t("Initializing upload"));
    uploadControllerRef.current = DBUploadDemViaBackend({
      projectId,
      file: data.demFile,
      onTransferComplete: handleFinishedUpload,
      onError: handleError,
      onProgressChange: (message) => setProgress(t(message)),
    });
  }

  function handleFinishedUpload(upload) {
    uploadControllerRef.current = null;
    setProgress(null);
    onUploadQueued(upload);
    onClose();
  }

  const [alert, setAlert] = useState(null);

  function handleError(err) {
    uploadControllerRef.current = null;
    setProgress(null);
    setAlert({
      cancleLabel: t("Close"),
      type: "error",
      message:
        err?.response?.data?.message ||
        err?.message ||
        t("DEM upload failed"),
    });
  }

  function handleClose() {
    if (uploadControllerRef.current) {
      uploadControllerRef.current.abort();
      uploadControllerRef.current = null;
    }
    setProgress(null);
    onClose();
  }

  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        sx={{
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "800px",
            maxHeight: "100%",
            padding: "25px",
          },
        }}
      >
        <LoadingBlur active={progress !== null} text={progress} />
        <ExoForm fields={fields} onSubmit={handleSave} onCancle={handleClose} />
      </Dialog>
      <ExoAlert
        open={Boolean(alert)}
        alert={alert || {}}
        onClose={() => setAlert(null)}
      />
    </>
  );
};
